class CustomMap {
    constructor() {
        this.customMapModule = document.querySelector(".js-custom-map");
        if(typeof this.customMapModule == 'undefined' || this.customMapModule == null) return false;
        this.mapData = JSON.parse(this.customMapModule.dataset.mapdata);
        var centerMapLat = parseFloat(this.mapData['mainMap']['lat']),
            centerMapLng = parseFloat(this.mapData['mainMap']['long']);

        if(isNaN(centerMapLat) || isNaN(centerMapLng)) {
            this.mapCenter = { lat: 0, lng: 0 };
        } else {
            this.mapCenter = { lat: centerMapLat, lng: centerMapLng };
        }
        this.mapStyle = [
            {
                "featureType": "administrative.land_parcel",
                "elementType": "labels",
                "stylers": [
                    {
                        "visibility": "off"
                    }
                ]
            },
            {
                "featureType": "administrative.neighborhood",
                "elementType": "labels",
                "stylers": [
                    {
                        "visibility": "off"
                    }
                ]
            },
            {
                "featureType": "landscape",
                "elementType": "labels",
                "stylers": [
                    {
                        "visibility": "off"
                    }
                ]
            },
            {
                "featureType": "landscape.man_made",
                "elementType": "geometry",
                "stylers": [
                    {
                        "color": "#ffffff"
                    }
                ]
            },
            {
                "featureType": "landscape.natural",
                "elementType": "geometry",
                "stylers": [
                    {
                        "color": "#ffffff"
                    }
                ]
            },
            {
                "featureType": "poi",
                "elementType": "geometry",
                "stylers": [
                    {
                        "visibility": "off"
                    }
                ]
            },
            {
                "featureType": "poi",
                "elementType": "labels.text",
                "stylers": [
                    {
                        "visibility": "off"
                    }
                ]
            },
            {
                "featureType": "poi.business",
                "stylers": [
                    {
                        "visibility": "off"
                    }
                ]
            },
            {
                "featureType": "poi.park",
                "stylers": [
                    {
                        "color": "#e5fcde"
                    }
                ]
            },
            {
                "featureType": "poi.park",
                "elementType": "geometry",
                "stylers": [
                    {
                        "color": "#e5ffe7"
                    }
                ]
            },
            {
                "featureType": "poi.park",
                "elementType": "labels.text",
                "stylers": [
                    {
                        "visibility": "off"
                    }
                ]
            },
            {
                "featureType": "road",
                "elementType": "geometry",
                "stylers": [
                    {
                        "color": "#ededed"
                    }
                ]
            },
            {
                "featureType": "road.arterial",
                "elementType": "geometry",
                "stylers": [
                    {
                        "color": "#d1d1d1"
                    },
                    {
                        "weight": 1.5
                    }
                ]
            },
            {
                "featureType": "road.highway",
                "elementType": "geometry",
                "stylers": [
                    {
                        "color": "#d1d1d1"
                    },
                    {
                        "weight": 1.5
                    }
                ]
            },
            {
                "featureType": "road.highway",
                "elementType": "labels",
                "stylers": [
                    {
                        "visibility": "off"
                    }
                ]
            },
            {
                "featureType": "road.local",
                "elementType": "geometry",
                "stylers": [
                    {
                        "color": "#e3e3e3"
                    },
                    {
                        "weight": 0.5
                    }
                ]
            },
            {
                "featureType": "road.local",
                "elementType": "labels",
                "stylers": [
                    {
                        "visibility": "off"
                    }
                ]
            },
            {
                "featureType": "transit",
                "elementType": "geometry",
                "stylers": [
                    {
                        "visibility": "off"
                    }
                ]
            },
            {
                "featureType": "water",
                "elementType": "geometry",
                "stylers": [
                    {
                        "color": "#deeefc"
                    }
                ]
            },
            {
                "featureType": "water",
                "elementType": "labels",
                "stylers": [
                    {
                        "visibility": "off"
                    }
                ]
            }
        ]; 
        this.map;
        this.mapContainer = this.customMapModule.querySelector('.js-custom-map-container');
        this.markerID = 0;
        this.markerAnimation;
        this.latlngbounds;
        this.infowindow = new google.maps.InfoWindow();
        this.markerElement = [];
        this.category = [];
        this.openFilter = this.customMapModule.querySelector('.js-custom-map-open-filter');
        this.categoryItems = this.customMapModule.querySelector('.js-custom-map-category');
        this.directory = this.mapContainer.dataset.directory
        this.markerArr = [];
        this.markerCluster;
    }

    mapInit() {
        var _self = this,
            mapCenter = _self.mapCenter;

        if(!this.mapData['styled']) {
            _self.mapStyle = '';
        }
        var mapZoom = 14;
        if(_self.mapData['zoom'] === 'manual') {
            mapZoom = parseInt(_self.mapData['zoom_level'])
        }

        _self.mapAnimation();

        const mapArr = {
            zoom: mapZoom,
            streetViewControl: false,
            mapTypeControl: false,
            zoomControlOptions: {
                position: google.maps.ControlPosition.RIGHT_BOTTOM,
            },
            center: _self.mapCenter,
            styles: _self.mapStyle,
        }
        
        if(mapCenter['lat'] && mapCenter['lng']) {
            _self.map = new google.maps.Map(_self.mapContainer, mapArr);
            _self.latlngbounds = new google.maps.LatLngBounds();
            _self.setCenterMarker();
        } else {
            return false;
        }       
    }

    mapAnimation() {  
        var _self = this;      
        if(_self.mapData['markerAnimationType'] == 'DROP') {
            _self.markerAnimation = google.maps.Animation.DROP
        } else {
            _self.markerAnimation = google.maps.Animation.BOUNCE
        }
    }

    setCenterMarker() {
        var _self = this,
            myLatlng = new google.maps.LatLng(_self.mapData['mainMap']['lat'], _self.mapData['mainMap']['long']);
        _self.setMarkerPosition(myLatlng, _self.mapData['mainMap']['icon']);
    }

    setMarkerPosition(Latlng, icon = '') {
        var _self = this;         
        var marker =  new google.maps.Marker({
            position: Latlng,
            icon: icon,
            animation: _self.markerAnimation,
            id: _self.markerID,
            map: _self.map
        });

        _self.latlngbounds.extend(marker.position);
        _self.markerArr.push(marker);
        
        if(this.mapData['enableInfoWindow']) {
            var contentString = _self.markerContent(_self.markerElement);
            marker.addListener("click", () => {
                _self.infowindow.close();
                _self.infowindow.setContent(contentString);
                _self.infowindow.open(_self.map, marker);
            })
        };
        _self.markerID++;
    }

    initPlaceMarker(data) {
        var _self = this;
        if(!data) return false
        let {desc, icon, lat, long, title} = _self.mapData['mainMap'];
        _self.latlngbounds = new google.maps.LatLngBounds();
        var centerMarker = {
            "cta_link": "",
            "info_image": false,
            "lat": lat,
            "long": long,
            "map_category": "center_map",
            "title": title,
            "desc": desc,
        };
        
        data = [...data, centerMarker];
        _self.markerArr = [];
        data.forEach((element, i) => {
            var latitude = parseFloat(element.lat),
                longitude = parseFloat(element.long),
                markerIcon = '',
                filters = _self.mapData['filters'],
                hasType = false;

            _self.markerElement = element;
            if(element.map_category === 'center_map') {
                markerIcon = _self.mapData['mainMap']['icon'] ?? '';
            } else if(filters) {
                hasType = filters.hasOwnProperty(element.type);
                if(hasType) {
                    markerIcon = _self.mapData.filters[element.type.toLowerCase()].markerIcon ?? '';
                }
            }
            
            if(latitude && longitude) {
                var myLatlng = new google.maps.LatLng(latitude, longitude);
                _self.setMarkerPosition(myLatlng, markerIcon);

                if(hasType) {
                    _self.category.push(element.type.toLowerCase());
                }
            }
        });


        _self.category = [...new Set(_self.category)];
        _self.map.setCenter(_self.latlngbounds.getCenter());

        if(_self.mapData['zoom'] == 'auto') {
            _self.map.fitBounds(_self.latlngbounds);
        } else {
            _self.map.setZoom(parseInt(_self.mapData['zoom_level']))
        }

        _self.mapClusterInit();      
    }

    markerContent(element) {
        if(!element) return false;
        var outputHtml = '';
        const {title, info_image, cta_link, desc} = element;
        outputHtml += `<div class="marker">
                            <div class="marker-card">`;
        if(info_image) {
            outputHtml += `${info_image.sizes.large ? `<div class="voyager-map__marker-card-thumbnail" style="background-image: url(${info_image.sizes.large})"></div>` : ''}`;
        }
                            
        outputHtml += `<div class="marker-card__content">
                                    ${title ? `<h3 class="marker-card__title">${title}</h3>` : ''}
                                    ${desc ? `<strong class="marker-card__location">${desc} <i class="fas fa-map-marker-alt"></i></strong>` : ''}`;
        if(cta_link && cta_link.url && cta_link.title) {
            outputHtml += `${cta_link.url ? `<a class="marker-card__link" href="${cta_link.url}" target="${cta_link.target}">${cta_link.title}</a>` : ''}`;
        }
        outputHtml += `</div></div></div>`;
        return outputHtml;
    }

    filterOpen() {
        var _self = this;
        _self.openFilter.addEventListener('click', function(){
            this.classList.toggle('is-active');
        })
    }

    setCategories() {
        var _self = this,
            outputHTML = '';
        if(_self.category.length === 0) {
            _self.categoryItems.parentElement.style.display = 'none';
            return false;
        } 

        _self.category.forEach(element => {
            let item = _self.mapData['filters'][element];
            outputHTML += `  <li><label class="voyager-map__filter-item" for="voyager_map_${item['name']}" tabindex="0">
                                <input type="checkbox" name="" id="voyager_map_${item['name']}" checked data-filter-type="${element}" class="voyager-map__checkbox" aria-labelledby="voyager_map_${item['name']}" tabindex="0">
                                <div class="voyager-map__filter-checkbox">
									<span class="voyager-map__filter-checkbox__indicator"></span>
								</div>
								<div class="voyager-map__filter-label">`;
            if(item['filterIcon']) {
                outputHTML += `<span class="voyager-map__filter-icon">
                                    <img src="${item['filterIcon']}" alt="${item['name']}" />
                                </span>`;
            }
            outputHTML += `<span class="voyager-map__filter-text">
									  ${item['name']}
									</span>
								</div>
                            </label></li>`;
        });					
        
        _self.categoryItems.insertAdjacentHTML('beforeend', outputHTML);        
        _self.mapFilter();
    }

    mapFilter() {
        var _self = this;
        let checkboxes = _self.categoryItems.querySelectorAll('input[type="checkbox"]'),
            markers = _self.mapData['markers'];
        _self.categoryItems.querySelectorAll('li').forEach(element => {   
            element.addEventListener('click', function (e) {        
                let filterCheck = this.querySelector('input[type="checkbox"]'),
                    filterType = filterCheck.dataset.filterType;
                    
                _self.removeMarker();
                let newMarkers = _self.mapData['markers'];
                if (filterType != 'all') {
                    checkboxes.forEach(function (item) {
                        if (item != filterCheck) {
                            item.checked = false;
                        } else {
                            item.checked = true;
                            newMarkers = markers.filter((i) => i.type.toLowerCase() === item.dataset.filterType);
                        }
                    });
                } else {                    
                    checkboxes.forEach(function (item) {
                        item.checked = true;
                    });
                }
                                  
                _self.initPlaceMarker(newMarkers);
                _self.openFilter.classList.remove('is-active');
            });
        });
    }

	mapClusterInit() {
		var _self = this;
		let clusterMarker = _self.markerArr;
		let clusterStyles = [
			{
				textColor: 'white',
				url: _self.directory +'/assets/img/blocks/map/cluster-marker-icon.svg',
				backgroundSize: '44',
				background: 'red',
				height: 44,
				width: 44,
				fontFamily: "'Open Sans', Arial",
				fontWeight: '400',
				textSize: '14',
				textLineHeight: '44',
				className: "custom-clustericon-1",
			}
		];

		_self.markerCluster = new MarkerClusterer(_self.map, clusterMarker, {
			gridSize: 44,
			clusterClass: 'cos--cluster',
			styles: clusterStyles,
			minimumClusterSize: 2,
			calculator: function (clusterMarker, numStyles) {
				if (clusterMarker.length >= 50) return { text: clusterMarker.length, index: 3 }
				if (clusterMarker.length >= 5) return { text: clusterMarker.length, index: 2 }
				return { text: clusterMarker.length, index: 0 }
			}
		});
	}

    removeMarker() {
        var _self = this,
            markerClusters = _self.markerCluster.getMarkers();
        for (let i = 0; i < markerClusters.length; i++) {
            markerClusters[i].setMap(null)
        }

        _self.markerCluster.clearMarkers()
    }

    init() {
        if(typeof this.customMapModule === 'undefined' || this.customMapModule === null) return false;
        var mapInit = this.mapInit();
        if(mapInit === false) return;
        this.initPlaceMarker(this.mapData['markers']);
        if(!this.mapData['markers']) return false;
        this.setCategories();
        this.filterOpen();
    }
}

function loadCustomMap() {
    const customMap = new CustomMap();
    customMap.init();
}

if (window.acf) {
	window.acf.addAction('render_block_preview/type=voyager-map', function () {
        loadCustomMap();
      });	
} else {	
    window.addEventListener("load", () => {
        loadCustomMap();
    });
} 